import './bar-stat.scss';

import BarStat from './BarStat';

export default BarStat;
